import type { GradeOriginType } from '@repo/types/grades';

export const GRADE_ORIGIN_CONFIG = {
  quizResponse: { label: 'Quiz', variant: 'blue' },
  assignmentResponse: { label: 'Zadanie', variant: 'orange' },
  other: { label: 'Ręczna', variant: 'muted' },
} as const satisfies Record<GradeOriginType, { label: string; variant: 'blue' | 'orange' | 'muted' }>;
